import { appMethod as app } from '@utils/app';
import { convertStyleData, transformPx2Rem } from '@utils/tools';

import './TextareaEleCustomComponent.less';

export default function TextareaEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   * @param {*} event 
   */
  const inputChange = (event) => {
    let dataset      = event.currentTarget.dataset;
    let value        = event.target.value;
    let pageInstance = app.getAppCurrentPage();
    let datakey      = dataset.datakey;
    let segment      = dataset.segment;

    if (!segment) {
      app.showModal({
        content: '该组件【多行文本】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    let newdata = {};
    newdata[datakey] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component textarea-ele" style={styleObj}>
      <textarea
        placeholder={ !!customFeature.placeholder ? customFeature.placeholder : ''}
        maxLength="-1"
        value={form_data[data.customFeature.segment]}
        onInput={inputChange}
        data-segment={data.customFeature.segment}
        data-datakey={`eles[${formCompindex}].form_data.${customFeature.segment}`}
      />
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/textarea-ele-custom-component/TextareaEleCustomComponent.jsx